<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div v-if="company" class="col-sm p-0">
        <div
          class="dashboard global__scrollcustom"
          v-if="profile.status === 'ANDALINVERIFICATION'"
        >
          <Header :dashboardHeader="dataHeader" />
          <p v-if="(company.saf.credit_balance === 150000000 && company.saf.credit_limit === 150000000) || (company.saf.credit_balance === 50000000 && company.saf.credit_limit === 50000000)" class="ml-4">Congratulations! You have been granted a credit limit of Rp {{ company.saf.credit_balance.toLocaleString() }} Start shipping now!</p>
          <div class="dashboard__page mb-4 mt-3 d-flex" style="column-gap: 1rem;">
            <router-link :to="todoList.link" class="ml-0 flex-fill">
              <TotalSpending
                :datas="dataToDoList"
                :isLoading="isLoadingSpendingYTD"
              />
            </router-link>
            <router-link :to="notifications.link" class="ml-0 flex-fill">
              <TotalSpending
                :datas="dataNotifications"
                :isLoading="isLoadingSpendingYTD"
              />
            </router-link>
            <!-- <div v-if="(company.saf.credit_limit > 0)" class="col-md-3">
              <Credit
              :datas="dataCredit"
              :isLoading="isLoadingSpendingYTD"
              />
            </div> -->
              <div class="flex-fill">
              <TotalSpending
                :datas="dataTotalSpending"
                :isLoading="isLoadingSpendingYTD"
              />
            </div>
          </div>

          <div class="dashboard__page">
            <div class="dashboard__page--reqlist">
              <RequestList />
              <OngoingShipment />
            </div>
          </div>

          <div class="row m-0 dashboard__page">
            <div class="dashboard__page--left col-md-8 p-0">
              <Analytics />
            </div>
            <div class="dashboard__page--right col-md p-0">
              <TimeAndSaving
                :datas="dataTimePerformance"
                :isLoading="isLoadingTimePerf"
              />
            </div>
          </div>

          <div class="row m-0 dashboard__page">
            <StorageCalculator />
          </div>
        </div>
        <div class="_verification_page" v-else>
          <div class="col-sm p-0">
            <div
              class="row m-0 afterverify_page align-items-center justify-content-center"
            >
              <div class="text-center">
                <img src="@/assets/image/icon/verified.svg" alt="" />
                <h5>
                  Please Upload All Document Required (SIUP, KTP, NPWP, NIB) in
                  the Settings Menu. We Will Contact You within 24 (Working)
                  Hours to Confirm Your Application.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/global/Sidebar.vue'
import Header from '@/components/dashboard/Header.vue'
import RequestList from '@/components/dashboard/RequestList.vue'
import OngoingShipment from '@/components/dashboard/OngoingShipment.vue'
import StorageCalculator from '@/components/dashboard/StorageCalculator.vue'
import InvoiceList from '@/components/dashboard/InvoiceList.vue'
import NotifAndTodolist from '@/components/dashboard/NotifAndTodolist.vue'
import Analytics from '@/components/dashboard/Analytics.vue'
import TimeAndSaving from '@/components/dashboard/TimeAndSaving.vue'
import TotalSpending from '@/components/dashboard/TotalSpending.vue'
import RoadMap from '@/components/dashboard/RoadMap.vue'
import Credit from '@/components/dashboard/Credit.vue'
import Mixin from '@/mixin'
import dashboardMixin from '@/mixin/dashboard/invoice_notif_todolist'
import * as countries from 'i18n-iso-countries'
import {
  DISPLAY_TIME_PERFORMANCE,
  DISPLAY_SAVINGS
} from '@/constant/page/dashboard'

export default {
  name: 'dashboard',
  components: {
    Sidebar,
    Header,
    RequestList,
    OngoingShipment,
    StorageCalculator,
    InvoiceList,
    NotifAndTodolist,
    Analytics,
    TimeAndSaving,
    TotalSpending,
    RoadMap,
    Credit
  },
  mixins: [Mixin, dashboardMixin],
  data () {
    return {
      prevRoute: '',
      dataHeader: {
        id: '',
        name: '',
        report: []
      },
      dataRecentShipping: [],
      overdueInvoice: {
        title: 'OVERDUE INVOICES',
        data: [],
        emptyData: {
          image: require('@/assets/image/icon/dashboard-overdue.svg'),
          text: "It's time to ship and grow your business!"
        },
        link: {
          route: {
            name: 'Payment',
            params: {
              type: 'unpaid'
            },
            query: {
              filter: 'overdue'
            }
          },
          text: 'See All Overdue Invoices'
        }
      },
      upcomingInvoice: {
        title: 'UPCOMING INVOICES',
        data: [],
        emptyData: {
          image: require('@/assets/image/icon/dashboard-upcoming.svg'),
          text: "It's time to ship and grow your business!"
        },
        link: {
          route: {
            name: 'Payment',
            params: {
              type: 'unpaid'
            },
            query: {
              filter: 'upcoming'
            }
          },
          text: 'See All'
        }
      },
      todoList: {
        title: 'TO DO LIST',
        subtitle: 'These items need your immediate action!',
        data: [],
        emptyData: {
          image: require('@/assets/image/icon/dashboard-todo.svg'),
          text: 'You have no action items at the moment. Great Job!'
        },
        link: {
          name: 'NotifAndToDo',
          params: {
            type: 'to-do-list'
          }
        }
      },
      notifications: {
        title: 'NOTIFICATIONS',
        subtitle: 'These shipments need your immediate attention !',
        data: [],
        emptyData: {
          image: require('@/assets/image/icon/dashboard-notif.svg'),
          text: 'You have no action items at the moment. Great Job!'
        },
        link: {
          name: 'NotifAndToDo',
          params: {
            type: 'notifications'
          }
        }
      },
      dataTimePerformance: {
        header: 'One Time Performance',
        body: {
          type: DISPLAY_TIME_PERFORMANCE,
          item: 0
        }
      },
      dataSavings: {
        header: 'Savings',
        body: {
          type: DISPLAY_SAVINGS,
          item: 0
        }
      },
      dataTotalSpending: {
        header: 'TOTAL SPENDING YTD',
        body: [],
        img: require('@/assets/image/icon/Totalspen.svg'),
        air: require('@/assets/image/icon/Air.svg'),
        ocean: require('@/assets/image/icon/Ocean.svg')
      },
      dataCredit: {
        header: 'CREDIT BALANCE',
        body: []
      },
      dataToDoList: {
        header: 'TO DO LIST',
        total: 0,
        body: [],
        img: require('@/assets/image/icon/Todo.svg'),
        link: {
          name: 'NotifAndToDo',
          params: {
            type: 'to-do-list'
          }
        }
      },
      dataNotifications: {
        header: 'NOTIFICATION',
        total: 0,
        body: [],
        img: require('@/assets/image/icon/Notif.svg'),
        link: {
          name: 'NotifAndToDo',
          params: {
            type: 'notifications'
          }
        },
        style: 'color: #C4232A'
      },
      dataCountryCode: {}
    }
  },
  computed: {
    ...mapGetters({
      // profile
      profile: 'auth/profile',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      itemOverdueInvoice: 'dashboard/itemOverdueInvoice',
      isLoadingItemOverdueInvoice: 'dashboard/isLoadingItemOverdueInvoice',
      errorItemOverdueInvoice: 'dashboard/errorItemOverdueInvoice',

      itemUpcomingInvoice: 'dashboard/itemUpcomingInvoice',
      isLoadingItemUpcomingInvoice: 'dashboard/isLoadingItemUpcomingInvoice',
      errorItemUpcomingInvoice: 'dashboard/errorItemUpcomingInvoice',

      rateList: 'rate/rateDashboard',

      itemRoadMap: 'dashboard/itemRoadMap',
      isLoadingItemRoadMap: 'dashboard/isLoadingItemRoadMap',
      errorItemRoadMap: 'dashboard/errorItemRoadMap',

      itemTimePerformance: 'dashboard/itemTimePerf',
      isLoadingTimePerf: 'dashboard/isLoadingTimePerf',
      errorTimePerf: 'dashboard/errorTimePerf',

      itemSavings: 'dashboard/itemSavings',
      isLoadingSavings: 'dashboard/isLoadingSavings',
      errorSavings: 'dashboard/errorSavings',

      itemSpendingYTD: 'dashboard/itemSpendingYTD',
      isLoadingSpendingYTD: 'dashboard/isLoadingSpendingYTD',
      errorSpendingYTD: 'dashboard/errorSpendingYTD',

      itemTodo: 'dashboard/itemTodo',
      isLoadingItemTodo: 'dashboard/isLoadingItemTodo',
      errorItemTodo: 'dashboard/errorItemTodo',

      itemNotif: 'dashboard/itemNotif',
      isLoadingItemNotif: 'dashboard/isLoadingItemNotif',
      errorItemNotif: 'dashboard/errorItemNotif',

      getCredit: 'dashboard/getCredit',
      errorGetCredit: 'dashboard/errorGetCredit',
      isLoadingGetCredit: 'dashboard/isLoadingGetCredit',

      getRoadmapCountry: 'dashboard/getRoadmapCountry',
      errorGetRoadmapCountry: 'dashboard/errorGetRoadmapCountry',
      isLoadingGetRoadmapCountry: 'dashboard/isLoadingGetRoadmapCountry',

      company: 'settingCompany/company'
    })
  },
  mounted: function () {
    if (this.profile.status === 'ANDALINVERIFICATION') {
      this.initDashboard()
    }
    this.removeLocalStorageFrom()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  methods: {
    removeLocalStorageFrom () {
      localStorage.removeItem('bookingFormData')
      localStorage.removeItem('instantPriceData')
    },
    
    async initDashboard () {
      this.fetchCompanyProfile()
      this.getNotification()
      this.getSpendingYTD()
      this.setHeader()
      this.getTodolist()
      this.fetchCredit()
      this.getTimePerformance()
      this.getUpcoming()
      this.getOverdue()
      this.getRoadMap()
      this.getSavings()
      this.fetchRoadmapCountry()
    },
    async fetchCompanyProfile () {
      await this.$store.dispatch('settingCompany/FETCH_COMPANY')
    },
    async fetchRoadmapCountry () {
      await this.$store.dispatch('dashboard/GET_ROADMAP_COUNTRY')
    },
    async fetchCredit () {
      await this.$store.dispatch('dashboard/FETCH_CREDIT')
    },
    async getOverdue () {
      await this.$store.dispatch('dashboard/FETCH_OVERDUE_INVOICE')
    },
    async getUpcoming () {
      await this.$store.dispatch('dashboard/FETCH_UPCOMING_INVOICE')
    },
    async getHeader () {
      await this.$store.dispatch('dashboard/FETCH_HEADER')
    },
    async getRoadMap () {
      await this.$store.dispatch('dashboard/FETCH_ROAD_MAP')
    },
    async getTimePerformance () {
      await this.$store.dispatch('dashboard/FETCH_TIME_PERFORMANCE')
    },
    async getSavings () {
      await this.$store.dispatch('dashboard/FETCH_SAVINGS')
    },
    async getSpendingYTD () {
      await this.$store.dispatch('dashboard/FETCH_SPENDING_YTD')
    },
    async getTodolist () {
      await this.$store.dispatch('dashboard/FETCH_TODO')
    },
    async getNotification () {
      await this.$store.dispatch('dashboard/FETCH_NOTIFICATION')
    },
    setHeader () {
      this.dataHeader.name = this.profile.customerName
      this.dataHeader.id = this.profile.customerId
        ? this.profile.customerId
        : '-'
    }
  },
  watch: {
    getRoadmapCountry (data) {
      if (data) {
        const obj = {}
        data.forEach((el) => {
          const key = countries.alpha3ToAlpha2(el.destination_country_code)
          obj[key] = el.totalShipment
        })
        this.dataCountryCode = obj
      }
    },
    prevRoute (data) {
      if (
        data.name === 'Signin' &&
        this.profile.status === 'ANDALINVERIFICATION'
      ) {
        this.$store.dispatch('rate/FETCH_DASHBOARD_RATE')
      }
    },
    itemHeader (data) {
      if (data) {
        this.setHeader(data)
      }
    },
    itemOverdueInvoice (data) {
      this.overdueInvoice.data = []
      if (data && data.length > 0) {
        data.forEach(item => {
          this.overdueInvoice.data.push(
            Object.assign({ alertImage: this.getAlertImage('HIGH') }, item)
          )
        })
      }
    },
    itemUpcomingInvoice (data) {
      this.upcomingInvoice.data = []
      if (data && data.length > 0) {
        data.forEach(item => {
          this.upcomingInvoice.data.push(
            Object.assign(
              { alertImage: this.getAlertImage(item.overdue, 'invoice') },
              item
            )
          )
        })
      }
    },
    itemSavings (data) {
      if (data) {
        this.dataSavings.body.item = data.saving_persen_avg
          ? data.saving_persen_avg.toFixed(2)
          : 0
      }
    },
    itemSpendingYTD (data) {
      if (data) {
        this.dataTotalSpending.body = data
      }
    },
    itemTimePerformance (data) {
      if (data) {
        this.dataTimePerformance.body.ontime = data.ontime
          ? data.ontime.toFixed(2)
          : 0
        this.dataTimePerformance.body.delay = data.delay
          ? data.delay.toFixed(2)
          : 0
        this.dataTimePerformance.body.inprogress = data.inprogress
          ? data.inprogress.toFixed(2)
          : 0
        this.dataTimePerformance.body.item = data.totalUncompletedShipment
      }
    },
    itemTodo (data) {
      this.dataToDoList.total = data.totalUnreadTodo
    },
    itemNotif (data) {
      this.dataNotifications.total = data.totalUnreadNotification
    },
    getCredit (data) {
      if (data) {
        this.dataCredit = data
      }
    }
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/view/dashboard/index.vue